import React, { useState } from "react";
import { Italic, Eyebrow } from "./_primitives";
import { PERSONAS } from "../../data/sparkseed";
import { Check } from "lucide-react";

export default function WhyPartner({ onOpenPitch, onOpenInvest }) {
  const [active, setActive] = useState(PERSONAS[0].id);
  const current = PERSONAS.find((p) => p.id === active);

  return (
    <section id="tracks" data-testid="why-partner-section" className="bg-[#DCE8C9] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
        <div className="max-w-3xl mb-12">
          <Eyebrow>Why Partner With Us</Eyebrow>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight font-bold text-[#0F2818]">
            For Every Stakeholder, There's a <Italic>Compelling</Italic> Case.
          </h2>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {PERSONAS.map((p) => (
            <button
              key={p.id}
              data-testid={`persona-tab-${p.id}`}
              onClick={() => setActive(p.id)}
              className={`px-5 py-2.5 rounded-full text-sm font-semibold border transition-all ${
                active === p.id
                  ? "bg-[#14401F] text-white border-[#14401F]"
                  : "bg-transparent text-[#0F2818] border-[#14401F]/20 hover:border-[#14401F]/50"
              }`}
            >
              {p.title}
            </button>
          ))}
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {PERSONAS.map((p) => {
            const isActive = active === p.id;
            return (
              <div
                key={p.id}
                data-testid={`persona-card-${p.id}`}
                className={`rounded-3xl p-7 lg:p-9 border transition-all ${
                  isActive
                    ? "bg-[#14401F] border-[#14401F] text-white shadow-2xl lg:scale-[1.02]"
                    : "bg-white/60 border-[#14401F]/10 text-[#0F2818] hover:bg-white"
                }`}
              >
                <div
                  className={`text-xs uppercase tracking-[0.25em] font-semibold mb-3 ${
                    isActive ? "text-[#B8D958]" : "text-[#14401F]"
                  }`}
                >
                  {p.id === "investors" ? "01 · LPs" : p.id === "founders" ? "02 · Builders" : "03 · Network"}
                </div>
                <h3 className={`font-serif-display text-2xl lg:text-3xl font-bold leading-tight mb-6 ${
                  isActive ? "text-white" : "text-[#0F2818]"
                }`}>
                  {p.title}
                </h3>
                <ul className="space-y-3">
                  {p.bullets.map((b, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span
                        className={`mt-1 h-5 w-5 rounded-full flex items-center justify-center flex-shrink-0 ${
                          isActive ? "bg-[#B8D958]" : "bg-[#DCE8C9]"
                        }`}
                      >
                        <Check
                          className={`h-3 w-3 ${isActive ? "text-[#0F2818]" : "text-[#14401F]"}`}
                          strokeWidth={3}
                        />
                      </span>
                      <span className={`text-sm ${isActive ? "text-white/90" : "text-[#0F2818]/85"}`}>
                        {b}
                      </span>
                    </li>
                  ))}
                </ul>

                {isActive && (
                  <button
                    onClick={p.id === "founders" ? onOpenPitch : onOpenInvest}
                    data-testid={`persona-cta-${p.id}`}
                    className="mt-8 w-full bg-[#B8D958] text-[#0F2818] hover:bg-[#a8c948] font-semibold rounded-full px-5 py-3 transition-all"
                  >
                    {p.id === "founders" ? "Pitch Your Startup" : p.id === "investors" ? "Become an LP" : "Partner With Us"}
                  </button>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
